import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useUserProfile } from "../../../contexts/UserProfileContext";
import Moment from "moment";
import "moment/locale/th";
import { useTranslation } from "react-i18next";
import { NotifyModal } from "../../../modal/NotifyModal";
import { getBuildDate } from "../../../utils";
import packageJson from "../../../../package.json";
import { appConfig } from "../../../authConfig";

export const ProfileService = (props: any) => {
  const { accounts } = useMsal();
  const { profile } = useUserProfile();
  const [showModal, setShowModal] = useState(false);
  const [btnConfirm, setbtnConfirm] = useState("no");
  const modalBackdrop = "true";
  const modalKeyboard = true;
  const modalTitle = "";
  const modalBody = "";

  // ใช้ข้อมูลจาก MSAL accounts แทนที่จะใช้ sessionStorage เพื่อป้องกันการ tampering
  const secureUserEmail =
    accounts && accounts.length > 0 ? accounts[0].username : null;
  const secureUserName =
    accounts && accounts.length > 0 ? accounts[0].name : null;

  if (typeof process.env.REACT_APP_NAME === "string") {
    document.title = process.env.REACT_APP_NAME;
  }

  if (localStorage.getItem("Language") === "en") {
    Moment.locale("en-sg");
  } else {
    Moment.locale("th");
  }

  const { t, i18n } = useTranslation();

  const changeLanguageTh = (th: any) => {
    i18n.changeLanguage(th);
    localStorage.setItem("Language", "th");
  };

  const changeLanguageEn = (en: any) => {
    i18n.changeLanguage(en);
    localStorage.setItem("Language", "en");
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      window.location.href =
        "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" +
        appConfig.appEndpoint.baseUrl;
    }, 1000);

    // instance.logoutRedirect().catch((e: any) => {
    //     console.error(e);
    // });
  };
  const hanleCancelRequest = () => {
    setShowModal(false);
    setbtnConfirm("no");
  };
  return (
    <>
      <NotifyModal
        btnText={t("btn_ok")}
        type="text"
        btnConfirm={btnConfirm}
        keyboard={modalKeyboard}
        backdrop={modalBackdrop}
        confirm={handleLogout}
        confirmFunc={handleLogout}
        title={modalTitle}
        body={modalBody}
        showModal={showModal}
        handleContinue={handleLogout}
        onHide={() => handleLogout()}
        onExiting=""
        Style={{ background: "#B7B8B9" }}
      />
      <div className="fix-box-header">
        <Container fluid className="header-bg">
          <Row>
            <Col xs={6}>
              <h4 className="hello mt-3 mb-2">HR Mobile </h4>

              <h4 className="welcome mb-0">
                {t("greet")}{" "}
                {process.env.REACT_APP_ENV
                  ? "(" + process.env.REACT_APP_ENV + ")"
                  : ""}
              </h4>
              <h4 className="m-0 p-0">
                <span
                  style={{
                    fontSize: "10px",
                    color: "#0d6dfd",
                    fontFamily: "blob",
                  }}
                >
                  Build Version : {packageJson.version} (
                  {getBuildDate(packageJson.buildDate)})
                </span>
              </h4>
            </Col>
            <Col
              xs={6}
              className="d-flex justify-content-end align-content-end mt-3"
            >
              <div className="switch-language d-flex justify-content-end">
                <span
                  className="p-1 pr-2"
                  onClick={() => changeLanguageTh("th")}
                >
                  <img
                    src="../images/th.svg"
                    alt="logo th"
                    width={25}
                    className={`${
                      localStorage.getItem("Language") === "th" ? "active" : ""
                    }`}
                  />
                  <p
                    className={`title + ${
                      localStorage.getItem("Language") === "th" ? "active" : ""
                    }`}
                  >
                    TH
                  </p>
                </span>
                <span className="p-1" onClick={() => changeLanguageEn("en")}>
                  <img
                    src="../images/en.svg"
                    alt="logo en"
                    width={25}
                    className={`${
                      localStorage.getItem("Language") === "en" ? "active" : ""
                    }`}
                  />
                  <p
                    className={`title + ${
                      localStorage.getItem("Language") === "en" ? "active" : ""
                    }`}
                  >
                    EN
                  </p>
                </span>
                <span className="p-1 ml-2" style={{ width: "80px" }}>
                  <div
                    className="icon-logout text-center"
                    onClick={() => handleLogout()}
                  >
                    <img
                      className="btn-login"
                      src="../images/icon-logout.svg"
                      width={25}
                      alt="logout"
                    />
                    <p className="text-logout">{t("logout_text")}</p>
                  </div>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
        {props.logo === "show" ? (
          <>
            <div className="profile-box pb-3">
              <Container>
                <Row>
                  <Col>
                    <div className="user-images">
                      <input
                        type="image"
                        className="img"
                        src="../images/icon/logo.png"
                        alt="user profile photo"
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
